import { render, staticRenderFns } from "./_siteInfo.vue?vue&type=template&id=3a1d5960&lang=pug"
import script from "./_siteInfo.vue?vue&type=script&lang=js"
export * from "./_siteInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports